// This is the correct code for: src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// NEW: Manually register the Firebase Messaging Service Worker
// This ensures that the 'firebase-messaging-sw.js' file is registered
// with the browser, allowing it to receive push notifications.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Firebase Messaging Service Worker registered:', registration);
    })
    .catch((error) => {
      console.error('Firebase Messaging Service Worker registration failed:', error);
    });
}
